/**
 * Typed boundary over the untyped `FetchApi` helpers for the Live Quran screen.
 */
import ApiNames from "../constants/ApiNames";
import { apiClient } from "./NetworkService";
import type { ApiResponse, QuranClassResponse } from "../types/liveQuran";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getQuranClass = async (token?: string): Promise<ApiResponse<QuranClassResponse>> => {
  const res = await apiClient.get(ApiNames.quranClass, getHeaders(token));
  return res.data;
};
